module.exports = __webpack_public_path__ + "static/media/cskaLogo.a56518a6.png";